import {UserStatus} from "@vesta/vos-types/modules/workspaceLevel/users/domain/User";

export function userStatusToDisplayName(userStatus: UserStatus): string {
    switch (userStatus) {
        case UserStatus.active: {
            return "Active";
        }
        case UserStatus.inactive: {
            return "Inactive";
        }
        case UserStatus.suspended: {
            return "Suspended";
        }
        case UserStatus.deleted: {
            return "Deleted";
        }
        case UserStatus.pending: {
            return "Pending";
        }
        case UserStatus.rejected: {
            return "Rejected";
        }
        default: {
            console.error("Invalid userStatus", userStatus);
            return "Unknown";
        }
    }
}
